import { render, staticRenderFns } from "./MyContents.vue?vue&type=template&id=9f4f630e&scoped=true&"
import script from "./MyContents.vue?vue&type=script&lang=js&"
export * from "./MyContents.vue?vue&type=script&lang=js&"
import style0 from "./MyContents.vue?vue&type=style&index=0&id=9f4f630e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4f630e",
  null
  
)

export default component.exports